import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { homepageAPI } from '../services/api';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://enessafoods.com';

const getFullImageUrl = (imagePath) => {
  if (!imagePath) return null;
  if (imagePath.startsWith('http')) return imagePath;
  return `${API_BASE_URL}${imagePath}`;
};

const BlogDetail = () => {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fallback blog data
  const fallbackBlogs = {
    1: { id: 1, category: 'Sustainability', time: '8 min read', title: 'Sustainable Baking Practices Every Modern Bakery Should Adopt', excerpt: 'Discover eco-friendly techniques...', date: 'Dec 15, 2024', author: 'Priya Sharma', image: '/assets/images/blogs/blog-1.jpg', content: 'Full blog content about sustainable baking practices...' },
    2: { id: 2, category: 'Innovation', time: '15 min read', title: 'The Rise of Clean-Label Baking: How to Stay Ahead', excerpt: 'Consumer trends are shifting...', date: 'Dec 10, 2024', author: 'Rajesh Kumar', image: '/assets/images/blogs/blog-2.jpg', content: 'Full blog content about clean-label baking...' },
    3: { id: 3, category: 'Production', time: '5 min read', title: '5 Ways to Improve Bread Quality Without Increasing Costs', excerpt: 'Practical tips for better products...', date: 'Dec 5, 2024', author: 'Amit Patel', image: '/assets/images/blogs/blog-3.jpg', content: 'Full blog content about improving bread quality...' }
  };

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const data = await homepageAPI.getBlogs();
        if (data && data.length > 0) {
          const foundBlog = data.find(b => b.id.toString() === id);
          if (foundBlog) {
            setBlog({
              ...foundBlog,
              image: getFullImageUrl(foundBlog.image)
            });
          } else {
            setBlog(fallbackBlogs[id]);
          }
        } else {
          setBlog(fallbackBlogs[id]);
        }
        setLoading(false);
      } catch (err) {
        setBlog(fallbackBlogs[id]);
        setLoading(false);
      }
    };

    fetchBlog();
  }, [id]);

  if (loading) {
    return (
      <div className="min-h-screen bg-white">
        <Header />
        <div className="max-w-4xl px-6 py-20 mx-auto">
          <div className="animate-pulse">
            <div className="h-8 mb-4 bg-gray-200 rounded"></div>
            <div className="mb-6 bg-gray-200 rounded h-96"></div>
            <div className="h-6 mb-2 bg-gray-200 rounded"></div>
            <div className="h-6 mb-2 bg-gray-200 rounded"></div>
            <div className="h-6 bg-gray-200 rounded"></div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  if (!blog) {
    return (
      <div className="min-h-screen bg-white">
        <Header />
        <div className="max-w-4xl px-6 py-20 mx-auto text-center">
          <h1 className="mb-4 text-4xl font-bold text-brown">Blog Not Found</h1>
          <p className="mb-8 text-brown-light">The blog post you're looking for doesn't exist.</p>
          <a href="/blogs" className="px-6 py-3 text-white rounded-full bg-primary hover:bg-primary/90">
            Back to Blogs
          </a>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Blog Content */}
      <article className="max-w-4xl px-6 py-20 mx-auto">
        {/* Back Button */}
        <a href="/blogs" className="inline-flex items-center mb-8 text-primary hover:underline">
          ← Back to Blogs
        </a>

        {/* Blog Header */}
        <header className="mb-8">
          <div className="flex items-center gap-3 mb-4">
            <span className="text-sm font-medium text-primary">{blog.category}</span>
            <span className="text-sm text-brown-light">• {blog.time}</span>
          </div>
          <h1 className="mb-4 font-serif text-4xl font-bold text-brown">{blog.title}</h1>
          <div className="mb-6 text-sm text-brown-light">
            {new Date(blog.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
          </div>
        </header>

        {/* Featured Image */}
        <div className="mb-8">
          <img 
            src={blog.image} 
            alt={blog.title} 
            className="object-cover w-full shadow-lg h-96 rounded-2xl"
          />
        </div>

        {/* Blog Content */}
        <div className="prose prose-lg max-w-none">
          <p className="mb-6 text-lg leading-relaxed text-brown-light">
            {blog.excerpt}
          </p>
          <div className="leading-relaxed whitespace-pre-line text-brown">
            {blog.blog_content || blog.content || 'This is where the full blog content would be displayed. The content would come from the backend or be stored as part of the blog data structure.'}
          </div>
        </div>

        {/* Share Section */}
        {/*<div className="pt-8 mt-12 border-t border-brown/10">
          <h3 className="mb-4 text-xl font-bold text-brown">Share this article</h3>
          <div className="flex gap-4">
            <button className="px-4 py-2 text-white bg-blue-500 rounded-lg hover:bg-blue-600">
              Share on LinkedIn
            </button>
            <button className="px-4 py-2 text-white bg-green-500 rounded-lg hover:bg-green-600">
              Share on WhatsApp
            </button>
            <button className="px-4 py-2 text-white bg-gray-500 rounded-lg hover:bg-gray-600">
              Copy Link
            </button>
          </div>
        </div>*/}
      </article>

      <Footer />
    </div>
  );
};

export default BlogDetail;